import { useContext } from 'react';
import { Button, Col, Modal, Row, Table, Tag } from 'antd';
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    GiftOutlined,
    PlayCircleOutlined,
    PlusOutlined,
    TrophyOutlined,
} from '@ant-design/icons';

import useGiveawaysAuto from './useGiveawaysAuto';
import PageHeader from '../../components/PageHeader';
import ActiveFiltersBar from '../../components/ActiveFiltersBar';
import TableCard from '../../components/TableCard';
import TableDicaHint from '../../components/TableDicaHint';
import TablePagination from '../../components/TablePagination';
import KpiCard from '../../components/KpiCard';
import { ThemeContext } from '../../contexts/ThemeContext';
import { poeValorComPontosEmMil } from '../../utils/Conversores';

export default function GiveawaysAuto() {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    const {
        isLoading,
        isDeleteModalVisible,
        isLoadingDelete,
        handleClickCreateNewGiveaway,
        handleConfirmDeleteGiveaway,
        handleCancelDeleteGiveaway,
        columns,
        tableData,
        totalGiveawaysCount,
        stats,
        pagination,
        activeFilterItems,
        handleTableChange,
        handlePaginationChange,
        handleClearAllFilters,
        giveawayBeingDeleted,
        navigate,
    } = useGiveawaysAuto();

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <PageHeader
                icon={<TrophyOutlined />}
                title="Sorteios (IPTU)"
                tag={<Tag color="blue">{poeValorComPontosEmMil(stats.total)} cadastrados</Tag>}
                subtitle="Gerencie, acompanhe e realize os sorteios de prêmios vinculados ao IPTU"
                actions={
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={handleClickCreateNewGiveaway}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            fontWeight: 600,
                            height: 38,
                            borderRadius: 8,
                        }}
                    >
                        Novo Sorteio
                    </Button>
                }
            />

            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<GiftOutlined />}
                        title="Total de Sorteios"
                        value={poeValorComPontosEmMil(stats.total)}
                        accentColor="#1677ff"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<PlayCircleOutlined />}
                        title="Sorteios Vigentes"
                        value={poeValorComPontosEmMil(stats.vigentes)}
                        accentColor="#722ed1"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<ClockCircleOutlined />}
                        title="Aguardando Sorteio"
                        value={poeValorComPontosEmMil(stats.aguardando)}
                        accentColor="#fa8c16"
                    />
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <KpiCard
                        icon={<CheckCircleOutlined />}
                        title="Sorteios Finalizados"
                        value={poeValorComPontosEmMil(stats.finalizados)}
                        accentColor="#52c41a"
                    />
                </Col>
            </Row>

            <ActiveFiltersBar
                filters={activeFilterItems}
                onClearAll={handleClearAllFilters}
            />

            <TableDicaHint text="Dê um clique em qualquer linha para abrir a visualização detalhada do sorteio, ou utilize os botões de ação à direita." />

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={totalGiveawaysCount}
                itemName="sorteios"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <TableCard>
                <Table
                    rowKey="id"
                    size="middle"
                    className={`modern-data-table ${isDark ? 'modern-data-table-dark' : ''}`}
                    columns={columns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    scroll={{ x: 1025 }}
                    onChange={handleTableChange}
                    onRow={(record) => ({
                        onClick: () => {
                            navigate(`/sorteios/auto/visualizar/${record.id}`);
                        },
                        style: {
                            cursor: 'pointer',
                        },
                    })}
                />
            </TableCard>

            <TablePagination
                current={pagination.current}
                pageSize={pagination.pageSize}
                total={totalGiveawaysCount}
                itemName="sorteios"
                pageSizeOptions={['10', '25', '50', '100']}
                onChange={handlePaginationChange}
            />

            <Modal
                title="Confirmar Exclusão"
                open={isDeleteModalVisible}
                onOk={handleConfirmDeleteGiveaway}
                okButtonProps={{
                    danger: true,
                    loading: isLoadingDelete,
                }}
                cancelButtonProps={{
                    disabled: isLoadingDelete,
                }}
                okText="Excluir Sorteio"
                cancelText="Cancelar"
                onCancel={handleCancelDeleteGiveaway}
                centered
            >
                <div style={{ padding: '12px 0' }}>
                    <p style={{ margin: 0, fontSize: 14 }}>
                        Tem certeza que deseja excluir o sorteio{' '}
                        <strong style={{ color: '#ff4d4f' }}>"{giveawayBeingDeleted?.description}"</strong>?
                    </p>
                    <p style={{ marginTop: 8, fontSize: 13, color: isDark ? '#a6a6a6' : '#64748b' }}>
                        Esta ação removerá permanentemente o sorteio e todas as suas configurações.
                    </p>
                </div>
            </Modal>
        </div>
    );
}
